import React from 'react';
import { Button, Icon } from '@chakra-ui/react';
import { MdArrowBack } from 'react-icons/md';
import { useNavigate, useSearchParams } from 'react-router-dom';
import AdminPageShell from '../../../components/layout/AdminPageShell';
import StockControlPanel from '../../../components/stock/StockControlPanel';
import { stockInventarioPath } from './stockPaths';
import authService from '../../../services/authService';

export default function StockControlPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session');
  const canEdit = authService.constructor.checkPermissionFromStorage('products.edit');
  const viewOnly = searchParams.get('view') === 'readonly' || !canEdit;
  const backToInventario = () => navigate(stockInventarioPath('controles'));

  const pageTitle = sessionId
    ? viewOnly
      ? 'Detalle del control'
      : 'Control de stock'
    : 'Nuevo control de stock';

  return (
    <AdminPageShell
      title={pageTitle}
      actions={
        <Button
          size="sm"
          variant="outline"
          leftIcon={<Icon as={MdArrowBack} />}
          onClick={backToInventario}
        >
          Inventario
        </Button>
      }
    >
      <StockControlPanel
        sessionId={sessionId ? Number(sessionId) : null}
        viewOnly={viewOnly}
        onSessionChange={
          viewOnly
            ? undefined
            : (id) => {
                if (id) {
                  navigate(`/admin/stock/control?session=${id}`, { replace: true });
                }
              }
        }
        onExit={backToInventario}
      />
    </AdminPageShell>
  );
}
